import { render, staticRenderFns } from "./modalEditAdvertorial.vue?vue&type=template&id=fd407bbe&"
import script from "./modalEditAdvertorial.vue?vue&type=script&lang=js&"
export * from "./modalEditAdvertorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports